

import React, { useRef, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './style.css';
import line from '../../Assets/Images/Line 14.png';
import ContactItem from '../../components/home/Contactus';
import phoneBg from '../../Assets/Images/Vector1.png';
import mailBg from '../../Assets/Images/Vector2.png';
import addressBg from '../../Assets/Images/Vector3.png';
import { FiPhoneCall } from 'react-icons/fi'; // Phone icon
import { BsEnvelope } from "react-icons/bs";
import { RiMapPinLine } from "react-icons/ri";
import { useLocation } from 'react-router-dom';

const ContactUs = () => {
    const [contact, setContact] = useState({}); // Initialize as an empty object
    const location = useLocation();
    const contactRef = useRef(null);


    useEffect(() => {
        if (location.hash === "#contact-section" && contactRef.current) {
            setTimeout(() => {
                const yOffset = -80;
                const y = contactRef.current.getBoundingClientRect().top + window.scrollY + yOffset;
                window.scrollTo({ top: y, behavior: "smooth" });
            }, 200);
        }
        fetchAboutUS();
    }, [location]);


    const fetchAboutUS = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/about-platform`);
            if (response.ok) {
                const data = await response.json();
                console.log(data);
                setContact(data); // Update the state with fetched data
            } else {
                console.error('Error fetching about us data');
            }
        } catch (error) {
            console.error('Error fetching about us data:', error);
        }
    };

    // Move contactData inside the component so it updates when contact changes
    const contactData = [
        {
            id: 1,
            iconClass: <FiPhoneCall size={26} />,
            title: 'Call Us',
            content: contact?.contactNumber
                ? `+91 ${contact.contactNumber}`
                : 'N/A',  // add +91 only if contactNumber exists
            // content: contact?.contactNumber || 'N/A', // Handle case where contact is empty
            bgImage: phoneBg
        },
        {
            id: 2,
            iconClass: <BsEnvelope size={26} />,
            title: 'Email Us',
            content: contact?.contactEmail || 'N/A',
            bgImage: mailBg
        },
        {
            id: 3,
            iconClass: <RiMapPinLine size={26} />,
            title: 'Address',
            content: contact?.platformAddress || 'N/A',
            bgImage: addressBg
        }
    ];

    return (
        <section id="contact-section" ref={contactRef}>
            <div className='contact-us-section 
            py-5 px-2 px-sm-3 py-md-5 py-md-5 px-md-3 p-lg-5 '
            >
                <h4 className='heading'>Contact Us</h4>
                <section className="d-flex flex-wrap justify-content-center align-content-center pt-5">
                    <div className="col-md-12 d-flex flex-wrap justify-content-center">
                        {contactData.map((item, index) => (
                            <React.Fragment key={item.id} >
                                <ContactItem
                                    iconClass={item.iconClass}
                                    title={item.title}
                                    content={item.content}
                                    bgImage={item.bgImage}
                                />
                                {index < contactData.length - 1 && (
                                    <div className='line px-5'>
                                        <img src={line} alt='line' className='img-fluid' />
                                    </div>
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                </section>
            </div>
        </section>
    );
};

export default ContactUs;

